
import localeAr from '@angular/common/locales/ar';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from 'projects/shared/src/helpers/error.interceptor';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { HeaderComponent } from './layouts/admin-layout/header/header.component';
import { SidebarComponent } from './layouts/admin-layout/sidebar/sidebar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActivatedRoute } from '@angular/router';
 import { NotAuthComponent } from 'projects/shared/src/pages/not-auth/not-auth.component';
import { enUsLocale, GANTT_GLOBAL_CONFIG, GANTT_I18N_LOCALE_TOKEN } from '@worktile/gantt';
import { enCA } from 'date-fns/locale';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { TabsLayoutComponent } from './layouts/tabs-layout/tabs-layout.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,

    AdminLayoutComponent,
    BlankLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    NotAuthComponent,
    BasicLayoutComponent,
    TabsLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgSelectModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('language') || 'ar',
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideAnimationsAsync(),
    {
      provide: GANTT_I18N_LOCALE_TOKEN,
      useValue: [enUsLocale]
    },
    {
      provide: GANTT_GLOBAL_CONFIG, useValue: {
        dateFormat: {
          yearQuarter: `QQQ 'of' yyyy`,
          month: 'LLLL',
          week: `'week 'w`,
          year: `yyy`,
          yearMonth: `LLL yyyy' (week 'w')'`
        },
        dateOptions: {
          locale: document.documentElement.lang == 'ar' ? localeAr : enCA,
          weekStartsOn: 6
        }
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['lang'] && (params['lang'] == 'ar' || params['lang'] == 'en')) {
        if (localStorage.getItem('language') !== params['lang']) {
          translate.use(params['lang']);
          localStorage.setItem('language', params['lang']);
          location.reload();
        }
      }
    });
  }
}

